<template>
  <div>
    <Header :title="title" />
    <div class="footer_podat">
      <div class="main">
        <div align="center">
          <button class="btns" @click="dale()">ОПУБЛИКОВАТЬ</button>
        </div>
      </div>
    </div>

    <div class="content_podat">
      <div v-if="loading" align="center">
        <div class="spinpodat"><Spinner /></div>
      </div>
      <div v-else>
        <div class="div_placeholder">Тел:</div>
        <div class="border_input">+992 {{ tel }}</div>
        <div class="div_placeholder">Имя</div>
        <input
          type="text"
          class="inputtt"
          v-model.trim="name_user_obv"
          placeholder=""
        />
        <div class="success">{{ text_success_name_user_obv }}</div>
        <div class="content_chat">
          <div class="checkbox">
            <input
              class="custom-checkbox"
              v-model="chat"
              type="checkbox"
              id="chat"
              name="chat"
              value="indigo"
            />
            <label for="chat">Чат</label>
          </div>
        </div>
        <div class="content_chat">
          <div class="checkbox">
            <input
              class="custom-checkbox"
              v-model="whatsapp"
              type="checkbox"
              id="whatsapp"
              name="whatsapp"
              value="indigo"
            />
            <label for="whatsapp">Whatsapp</label>
          </div>
        </div>

        <div class="pravila_podat_obv">
          <router-link  to="/pravila">Я соглашаюсь с <u>правилами использования сервиса</u>, а также с передачей и обработкой моих данных в Avtobaza.tj. <br/>Я подтверждаю своё совершеннолетие и ответсвенность за размещение объявления</router-link>
        </div>
      
      </div>
    </div>
    <modalupload v-if="startupload">
      <div slot="body">
        <table>
          <tr>
            <td><Spinner /></td>
            <td width="100%">
              <div class="font_20">
                Подождите, данны и фото отправляются на сервер.
              </div>
              <div class="font_20">{{ indicator_upload_image }}</div>
            </td>
          </tr>
        </table>
      </div>
    </modalupload>
    <noconnection
      :propsmodalalert="propsmodalalert"
      @emitnoconnection="emitnoconnection"
    />
  </div>
</template>
<script>
import Header from "../components/headerpodat";
import axios from "axios";
import Spinner from "../blocks/spinner";
import modalupload from "../blocks/modalupload";
import noconnection from "../blocks/noconnection";
export default {
  components: {
    Header,
    Spinner,
    modalupload,
    noconnection,
  },
  data() {
    return {
      title: "Контактная информация",
      loading: false,
      title_obv: "",
      name_user_obv: "",
      propsmodalalert: false,
      tel: "",
      chat: true,
      whatsapp: true,
      text_success_name_user_obv: "",
      indicator_upload_image: "",
      status_success: true,
      startupload: false,
      img_crop: "",
      image_p: "",
      images:"",
      id_opsiya:"",
      i: 0,
      opsiya: "",
    };
  },
  methods: {
    dale() {
      if (this.gorod && this.sena && this.kateg) {
        this.startupload = true;
        if (this.foto.length > 0) {
          this.i = 0;
          this.upload_image();
        } else {
          this.image_p =
            "https://imgagros.ru/storage/img/11111111111111111/4549/placeavto.jpg";
          this.senddata();
        }
      }
    },
    upload_image() {
      if (this.foto[this.i].image.length > 200) {
        try {
          axios({
            method: "post",
            url: "https://imgagros.ru/api/imgWfffRbbbGppp4fgfg",
            data: {
              image: this.foto[this.i].image,
              token:localStorage.getItem("token")
            },
            onUploadProgress: function (progressEvent) {
              this.indicator_upload_image =
                parseInt(
                  Math.round((progressEvent.loaded / progressEvent.total) * 100)
                ) + "%" +"  " + "(" + (this.i + 1) + "/" + this.foto.length +")";
            }.bind(this),
          })
            .then((res) => {
              if (res.data.status) {
                
                this.i++;
                if(this.i==1) this.img_crop=res.data.answer;
                if(this.images) this.images=this.images+"|"+res.data.answer;
                 else this.images=this.images+res.data.answer;
                if (this.i < this.foto.length) {
                  this.upload_image();
                } else {
                    this.indicator_upload_image = "";
                    this.cropImage();
                }
              } else {
                alert("ERROR");
              }
            })
            .catch((error) => {
              if (!error.response) {
                // network error
                this.startupload = false;
                this.propsmodalalert = true;
              }
            });
        } catch (e) {
          alert("Error");
        }
      } else {
        
        if(this.images) this.images=this.images+"|"+ this.foto[this.i].image;
        else this.images=this.images+this.foto[this.i].image;
        this.i++;
       if(this.i==1) this.img_crop=this.foto[this.i-1].image;
        
        if (this.i < this.foto.length) {
          this.upload_image();
        } else {
            this.indicator_upload_image = "";
            this.cropImage();
        }
      }
    },

    cropImage() {
      try {
        axios({
          method: "post",
          url: "https://imgagros.ru/api/crop",
          data: {
            image_p: this.img_crop,
          },
        })
          .then((res) => {
            if (res.data.status) {
              this.image_p = res.data.answer;
              this.senddata();
            } else {
              this.indicator_upload_image = false;
            }
          })
          .catch((error) => {
            if (!error.response) {
              this.startupload = false;
              this.propsmodalalert = true;
            }
          });
      } catch (e) {
        alert("Error");
      }
    },

    senddata() {
      if(this.chat)this.chat = false;
      else this.chat = true;
      if(this.whatsapp)this.whatsapp = false;
      else this.whatsapp = true;
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("token");
      try {
        axios({
          method: "post",
          url: "https://avtobaza.tj/api/podat",
          data: {
            id:this.id,
            title: this.zagolovok,
            name: this.name_user_obv,
            gorod: this.gorod,
            gorod_text: this.gorod_text,
            tip: this.tip,
            tip_text: this.tip_text,
            kateg: this.kateg,
            kateg_text: this.kateg_text,
            podkateg: this.podkateg,
            podkateg_text: this.podkateg_text,
            marka: this.marka,
            marka_text: this.marka_text,
            model: this.model,
            model_text: this.model_text,
            god: this.god,
            kuzov: this.kuzov,
            kuzov_text: this.kuzov_text,
            color: this.color,
            color_text: this.color_text,
            topliva: this.topliva,
            topliva_text: this.topliva_text,
            karobka: this.karobka,
            karobka_text: this.karobka_text,
            privod: this.privod,
            privod_text: this.privod_text,
            kompleckt: this.kompleckt,
            kompleckt_text: this.kompleckt_text,
            obdvigatel: this.obdvigatel,
            probeg: this.probeg,
            opsiya: this.opsiya,
            id_opsiya:this.id_opsiya,
            tipdiski: this.tipdiski,
            tipshina: this.tipshina,
            profil: this.profil,
            diametr: this.diametr,
            shirina: this.shirina,
            pcd: this.pcd,
            sostoyanie: this.sostoyanie,
            body: this.body,
            sena: this.sena,
            torg: this.torg,
            gosnomer: this.gosnomer,
            chat: this.chat,
            whatsapp:this.whatsapp,
            imgp: this.image_p,
            images: this.images,
            obmen:this.obmen,
            obmen_text:this.obmen_text,
            token: localStorage.getItem("token"),
          },
        })
          .then((res) => {
            if (!res.data.message) {
              if (res.data.status) {
                this.indicator_upload_image = true;
                this.$store.commit("addpostuser", new Array());
                this.$store.commit("addpodatfoto", new Array());
                this.$store.commit("addpodatopsiya", new Array());
                this.$store.commit("addpodatgorod", "");
                this.$store.commit("addpodattip", "");
                this.$store.commit("addpodatkateg", "");
                this.$store.commit("addpodatpodkateg", "");
                this.$store.commit("addpodatmarka", "");
                this.$store.commit("addpodatmodel", "");
                this.$store.commit("addpodatkuzov", "");
                this.$store.commit("addpodatcolor", "");
                this.$store.commit("addpodatgod", "");
                this.$store.commit("addpodattopliva", "");
                this.$store.commit("addpodatkarobka", "");
                this.$store.commit("addpodatprivod", "");
                this.$store.commit("addpodatobdvigatel", "");
                this.$store.commit("addpodatsena", "");
                this.$store.commit("addpodatbody", "");
                this.$store.commit("addpodatprobeg", "");
                this.$store.commit("addpodattorg", "false");
                this.$store.commit("addpodatgosnomer", "false");
                this.$store.commit("addpodatzagolovok", "");
                this.$store.commit("addpodatkompleckt", "");
                this.$store.commit("addpodattipshina", "");
                this.$store.commit("addpodattipdiski", "");
                this.$store.commit("addpodatprofil", "");
                this.$store.commit("addpodatdiametr", "");
                this.$store.commit("addpodatshirina", "");
                this.$store.commit("addpodatpcd", "");
                this.$store.commit("addpodatsostoyanie", "bu");
                this.$store.commit("addpodatchat", "false");
                this.$store.commit("addpodatwhatsapp", "false");
                this.$store.commit("addpodatid", "");
                this.$store.commit("addpodatobmen","");
                this.$store.commit("addpodatobmentext","");
                this.$router.push({ path: '/cbn' });
              } else {
                this.startupload = false;
                if (res.data.put)
                  this.$router.push({ path: "/podat" + res.data.put });
                else alert("Произошла ошибка попробуйте снова");
              }
            } else {
              localStorage.removeItem("token");
              this.$router.go();
            }
          })
          .catch((error) => {
            if (!error.response) {
              this.startupload = false;
              this.propsmodalalert = true;
            }
          });
      } catch (e) {
        alert("Error");
      }
    },
    emitnoconnection() {
      this.propsmodalalert = false;
      this.dale();
    },
  },
  computed: {
    tip() {
      return this.$store.getters.getpodattip;
    },
    id() {
      return this.$store.getters.getpodatid;
    },
    tip_text() {
      return this.$store.getters.getpodattip_text;
    },
    gorod() {
      return this.$store.getters.getpodatgorod;
    },
    gorod_text() {
      return this.$store.getters.getpodatgorod_text;
    },
    kateg() {
      return this.$store.getters.getpodatkateg;
    },
    kateg_text() {
      return this.$store.getters.getpodatkateg_text;
    },
    podkateg() {
      return this.$store.getters.getpodatpodkateg;
    },
    podkateg_text() {
      return this.$store.getters.getpodatpodkateg_text;
    },
    marka() {
      return this.$store.getters.getpodatmarka;
    },
    marka_text() {
      return this.$store.getters.getpodatmarka_text;
    },
    model() {
      return this.$store.getters.getpodatmodel;
    },
    model_text() {
      return this.$store.getters.getpodatmodel_text;
    },
    god() {
      return this.$store.getters.getpodatgod;
    },
    kuzov() {
      return this.$store.getters.getpodatkuzov;
    },
    kuzov_text() {
      return this.$store.getters.getpodatkuzov_text;
    },
    color() {
      return this.$store.getters.getpodatcolor;
    },
    color_text() {
      return this.$store.getters.getpodatcolor_text;
    },
    topliva() {
      return this.$store.getters.getpodattopliva;
    },
    topliva_text() {
      return this.$store.getters.getpodattopliva_text;
    },
    karobka() {
      return this.$store.getters.getpodatkarobka;
    },
    karobka_text() {
      return this.$store.getters.getpodatkarobka_text;
    },
    privod() {
      return this.$store.getters.getpodatprivod;
    },
    privod_text() {
      return this.$store.getters.getpodatprivod_text;
    },
    kompleckt() {
      return this.$store.getters.getpodatkompleckt;
    },
    kompleckt_text() {
      return this.$store.getters.getpodatkompleckt_text;
    },
    obdvigatel() {
      return this.$store.getters.getpodatobdvigatel;
    },
    sena() {
      return this.$store.getters.getpodatsena;
    },
    body() {
      return this.$store.getters.getpodatbody;
    },
    probeg() {
      return this.$store.getters.getpodatprobeg;
    },
    torg() {
      return this.$store.getters.getpodattorg;
    },
    gosnomer() {
      return this.$store.getters.getpodatgosnomer;
    },
    getopsiya() {
      return this.$store.getters.getpodatopsiya;
    },
    zagolovok() {
      return this.$store.getters.getpodatzagolovok;
    },
    tipdiski() {
      return this.$store.getters.getpodattipdiski;
    },
    tipshina() {
      return this.$store.getters.getpodattipshina;
    },
    profil() {
      return this.$store.getters.getpodatprofil;
    },
    diametr() {
      return this.$store.getters.getpodatdiametr;
    },
    shirina() {
      return this.$store.getters.getpodatshirina;
    },
    pcd() {
      return this.$store.getters.getpodatpcd;
    },
    sostoyanie() {
      return this.$store.getters.getpodatsostoyanie;
    },
    foto() {
      return this.$store.getters.getpodatfoto;
    },
    getpostuser() {
      return this.$store.getters.getpostuser;
    },
    getchat() {
      return this.$store.getters.getpodatchat;
    },
    getwhatsapp() {
      return this.$store.getters.getpodatwhatsapp;
    },
    obmen() {
        return this.$store.getters.getpodatobmen;
    },
    obmen_text() {
    return this.$store.getters.getpodatobmentext;
    },
   
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.go(-1);
    }
  },
  mounted() {
    if (this.getchat) this.chat = false;
    else this.chat = true;
    if (this.getwhatsapp) this.whatsapp = false;
    else this.whatsapp = true;
    this.getopsiya.forEach((element) => {
      if (element.status){
         this.opsiya = this.opsiya + element.text + ", ";
         this.id_opsiya=this.id_opsiya + element.id+"|";
      } 
    });
    if (this.getpostuser.name) {
       this.name_user_obv = this.getpostuser.name;
       this.tel = this.getpostuser.tel;
    } else {
      this.loading = true;
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("token");
      try {
        axios({
          method: "post",
          url: "https://avtobaza.tj/api/useragros",
          data: {
            token: localStorage.getItem("token"),
          },
        })
          .then((res) => {
            if (!res.data.message) {
              if (res.data.status) {
                this.loading = false;
                this.name_user_obv = res.data.user.name;
                this.tel = res.data.user.tel;
              } else {
                localStorage.removeItem("token");
                this.$router.go();
              }
            } else {
              localStorage.removeItem("token");
              this.$router.go();
            }
          })
          .catch((error) => {
            if (!error.response) {
              this.propsmodalalert = true;
            }
          });
      } catch (e) {
        alert("Error");
      }
    }
  },
};
</script>
<style scoped>
.content_podat {
  padding: 90px 10px 65px 10px;
}
.inputtt {
  width: 98%;
  border: 1px solid #555;
  padding: 11px 0px 11px 5px;
  font-size: 20px;
  border-radius: 5px;
}
.border_input {
  width: 98%;
  border: 1px solid #555;
  border-radius: 5px;
  padding: 11px 0px 11px 5px;
  font-size: 19px;
  margin-bottom: 20px;
}
.content_chat {
  margin-left: -18px;
  margin-top: 25px;
}
.pravila_podat_obv{
  margin-top: 30px;
}
.pravila_podat_obv a{
  text-decoration: none;
  color: #555;
  font-size: 14px;
}
</style>